// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AI Test Case Generator Styles */

/* BDD Scenario Styles */
.bdd-steps {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 0.5rem;
}

.bdd-step {
  display: flex;
  padding: 0.5rem;
  border-radius: 4px;
  background-color: var(--bg-tertiary, #f8f9fa);
  color: var(--text-primary, #212529);
}

.bdd-step.given {
  border-left: 3px solid #4a6cf7;
}

.bdd-step.when {
  border-left: 3px solid #fd7e14;
}

.bdd-step.then {
  border-left: 3px solid #28a745;
}

.step-keyword {
  font-weight: 600;
  margin-right: 0.5rem;
  min-width: 50px;
}

.step-text {
  flex: 1 1;
}

/* Scenario Type Badges */
.scenario-type-badge {
  display: inline-block;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
  margin-right: 0.5rem;
}

.scenario-type-badge.bdd {
  background-color: rgba(74, 108, 247, 0.1);
  color: #4a6cf7;
}

.scenario-type-badge.happy_path {
  background-color: rgba(40, 167, 69, 0.1);
  color: #28a745;
}

.scenario-type-badge.edge_case {
  background-color: rgba(253, 126, 20, 0.1);
  color: #fd7e14;
}

/* Card styling based on scenario type */
.test-case-card.bdd-card {
  border-top: 3px solid #4a6cf7;
}

.test-case-card.happy_path-card {
  border-top: 3px solid #28a745;
}

.test-case-card.edge_case-card {
  border-top: 3px solid #fd7e14;
}

/* Analysis Results */
.analysis-results {
  background-color: var(--surface, #fff);
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.analysis-results h3 {
  font-size: 1rem;
  font-weight: 600;
  margin-top: 0;
  margin-bottom: 0.75rem;
  color: var(--text-dark, #2d3748);
}

.analysis-stats {
  display: flex;
  gap: 1.5rem;
}

.analysis-stat {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.stat-label {
  font-size: 0.75rem;
  color: var(--text-muted, #718096);
}

.stat-value {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--text-dark, #2d3748);
}

.back-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background-color: var(--bg-tertiary, #f8f9fa);
  border: 1px solid #dee2e6;
  border-radius: 4px;
  color: #495057;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;
}

.back-btn:hover {
  background-color: var(--bg-tertiary, #e9ecef);
  border-color: #adb5bd;
  color: #212529;
}

.back-btn:active {
  background-color: #dee2e6;
  transform: translateY(1px);
}
.ai-testcase-generator-overlay {
  position: fixed;
  top: var(--rt-topbar-h, 56px);
  left: var(--rt-shell-sidebar-offset, var(--rt-sidebar-collapsed, 68px));
  right: 0;
  bottom: 0;
  display: flex;
  align-items: stretch;
  justify-content: stretch;
  z-index: 25;
  animation: fadeIn 0.2s ease;
  transition: left 180ms ease;
}

@media (max-width: 1024px) {
  .ai-testcase-generator-overlay {
    left: 0;
  }
}

.ai-testcase-generator-container {
  background-color: var(--surface, #fff);
  margin-top:8rem;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  width: 100vw;
  /* max-width: 1200px; */
  height: 100vh;
  display: flex;
  flex-direction: column;
  animation: slideUp 0.3s ease;
  color: var(--text-primary, #212529);
}

.generator-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid var(--border-color, #e9ecef);
}

.generator-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: var(--text-primary, #212529);
  display: flex;
  align-items: center;
  gap: 10px;
}

.ai-badge {
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  color: white;
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 4px;
  font-weight: 500;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: var(--text-muted, #6c757d);
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}

 .close-btn:hover {
  /* background-color: var(--bg-light, #f8f9fa); */
  color: var(--text-primary, #212529);
} 

.item-details {
  padding: 16px 24px;
  border-bottom: 1px solid var(--border-color, #e9ecef);
  background-color: var(--bg-light, #f8f9fa);
}

.item-title {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.item-type-badge {
  background-color: #e3f2fd;
  color: #0d6efd;
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 4px;
  font-weight: 600;
}

.item-title h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary, #212529);
}

.item-description {
  margin: 0;
  color: var(--text-secondary, #6c757d);
  font-size: 14px;
}

.generator-content {
  flex: 1 1;
  padding: 24px;
  overflow-y: auto;
}

/* Loading Spinner */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 40px;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top-color: #0d6efd;
  animation: spin 1s ease-in-out infinite;
  margin-bottom: 20px;
}

.loading-subtext {
  color: var(--text-muted, #6c757d);
  font-size: 14px;
  margin-top: 8px;
  text-align: center;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Test Cases Header */
.test-cases-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.test-cases-title {
  display: flex;
  align-items: center;
  gap: 16px;
}

.test-cases-title h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary, #212529);
}

.regenerate-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: var(--bg-tertiary, #f8f9fa);
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 14px;
  color: #495057;
  cursor: pointer;
  transition: all 0.2s ease;
}

.regenerate-btn:hover {
  background-color: var(--bg-tertiary, #e9ecef);
}

.regenerate-btn svg {
  color: #0d6efd;
}
.generate-test-case-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: blue;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 14px;
  color: white;
  cursor: pointer;
  transition: all 0.2s ease;
}
.test-cases-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.select-all-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.select-all-container input[type="checkbox"] {
  width: 16px;
  height: 16px;
}

.select-all-container label {
  font-size: 14px;
  color: var(--text-primary, #212529);
}

.save-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #0d6efd;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  color: white;
  cursor: pointer;
  transition: all 0.2s ease;
}

.save-btn:hover {
  background-color: #0b5ed7;
}

.save-btn:disabled {
  background-color: #b6d4fe;
  cursor: not-allowed;
}

.save-btn.saving {
  background-color: #6c757d;
}

.save-btn.saved {
  background-color: #28a745;
}

.btn-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: spin 1s ease-in-out infinite;
}

/* Test Cases List */
.test-cases-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.test-case-card {
  border: 1px solid var(--border, #dee2e6);
  border-radius: 8px;
  padding: 16px;
  background-color: var(--surface, #fff);
  color: var(--text-primary, #212529);
  transition: all 0.2s ease;
}

/* Collapsible behavior: animate height and opacity of content when toggling */
.test-case-card .test-case-meta,
.test-case-card .test-case-description,
.test-case-card .test-case-content {
  transition: max-height 0.32s cubic-bezier(.2,.8,.2,1), opacity 0.2s ease, transform 0.28s ease;
  overflow: hidden;
}

.test-case-card.collapsed .test-case-meta,
.test-case-card.collapsed .test-case-description,
.test-case-card.collapsed .test-case-content {
  max-height: 0; /* hide content */
  opacity: 0;
  transform: translateY(-6px);
  pointer-events: none;
}

.test-case-card.open .test-case-meta,
.test-case-card.open .test-case-description,
.test-case-card.open .test-case-content {
  max-height: 2000px; /* large value to allow content to expand */
  opacity: 1;
  transform: translateY(0);
  pointer-events: auto;
}

/* Collapsed summary styling */
.collapsed-summary {
  display: flex;
  gap: 12px;
  align-items: center;
  color: var(--text-secondary, #6c757d);
}
.collapsed-summary .short-description {
  color: var(--text-secondary, #6c757d);
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 60%;
}

/* Header caret indicator */
.test-case-header::after {
  content: '\\25BE'; /* small down-pointing triangle */
  display: inline-block;
  margin-left: 12px;
  transition: transform 0.28s ease, opacity 0.18s ease;
  opacity: 0.7;
}
.test-case-card.open .test-case-header::after {
  transform: rotate(180deg);
}
.test-case-card.collapsed .test-case-header::after {
  transform: rotate(0deg);
}

.test-case-card.selected {
  border-color: #0d6efd;
  box-shadow: 0 0 0 1px #0d6efd;
}

.test-case-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
}

.test-case-selection {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.test-case-selection input[type="checkbox"] {
  width: 18px;
  height: 18px;
  margin-top: 2px;
}

.test-case-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary, #212529);
  cursor: pointer;
}

.test-case-actions {
  display: flex;
  gap: 8px;
}

.edit-test-case-btn {
  background: none;
  border: none;
  color: var(--text-muted, #6c757d);
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.edit-test-case-btn:hover {
  background-color: var(--bg-tertiary, #f8f9fa);
  color: #0d6efd;
}

.test-case-meta {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.priority-badge {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.priority-high {
  background-color: #f8d7da;
  color: #dc3545;
}

.priority-medium {
  background-color: #fff3cd;
  color: #fd7e14;
}

.priority-low {
  background-color: #d1e7dd;
  color: #20c997;
}

.priority-critical {
  background-color: #dc3545;
  color: white;
}

.risk-impact-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  background-color: #e2e8f0;
  color: #4a5568;
}

.time-estimate {
  display: flex;
  align-items: center;
  gap: 4px;
  color: var(--text-muted, #6c757d);
  font-size: 12px;
}

.test-case-description {
  margin-bottom: 16px;
  color: var(--text-secondary, #6c757d);
  font-size: 14px;
}

.test-case-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.test-case-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.test-case-section h4 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary, #212529);
  background: transparent;
  box-shadow: none;
  border: none;
  padding: 0;
  text-shadow: none;
}

/* Preconditions List */
.preconditions-list {
  margin: 0;
  padding-left: 20px;
}

.preconditions-list li {
  margin-bottom: 4px;
  color: var(--text-secondary, #495057);
  font-size: 14px;
}

/* Expected Result */
.expected-result {
  padding: 8px 12px;
  background-color: var(--bg-tertiary, #f8f9fa);
  border-left: 3px solid var(--success, #28a745);
  border-radius: 4px;
  color: var(--text-secondary, #495057);
  font-size: 14px;
}

/* Parameterized Test Suggestions */
.parameterized-suggestions {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.parameter-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.parameter-name {
  font-weight: 600;
  font-size: 14px;
  color: var(--text-primary, #212529);
}

.parameter-values {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.parameter-value {
  display: inline-block;
  padding: 4px 8px;
  background-color: var(--bg-tertiary, #e9ecef);
  border-radius: 4px;
  font-size: 12px;
  color: var(--text-secondary, #495057);
}

.test-case-section ol, .test-case-section ul {
  margin: 0;
  padding-left: 20px;
}

.test-case-section li {
  margin-bottom: 4px;
  color: var(--text-secondary, #495057);
  font-size: 14px;
}

.test-case-section p {
  margin: 0;
  color: var(--text-secondary, #495057);
  font-size: 14px;
}

.no-test-cases {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  text-align: center;
  color: var(--text-muted, #6c757d);
}

/* Test Case Editor */
.test-case-editor-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000;
  animation: fadeIn 0.2s ease;
}

.test-case-editor {
  background-color: var(--surface, #fff);
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  width: 80%;
  max-width: 800px;
  height: 70vh;
  display: flex;
  flex-direction: column;
  animation: slideUp 0.3s ease;
}

.editor-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid var(--border-color, #e9ecef);
}

.editor-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary, #212529);
}

.close-editor-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: var(--text-muted, #6c757d);
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}

.close-editor-btn:hover {
  background-color: var(--bg-light, #f8f9fa);
  color: var(--text-primary, #212529);
}

.editor-content {
  flex: 1 1;
  padding: 16px 24px;
  overflow-y: auto;
}

.editor-textarea {
  width: 100%;
  height: 100%;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 12px;
  font-family: monospace;
  font-size: 14px;
  resize: none;
}

.editor-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid var(--border-color, #e9ecef);
}

.cancel-btn {
  background-color: var(--bg-tertiary, #f8f9fa);
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 14px;
  color: #495057;
  cursor: pointer;
  transition: all 0.2s ease;
}

.cancel-btn:hover {
  background-color: var(--bg-tertiary, #e9ecef);
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* Responsive Styles */
@media (max-width: 768px) {
  .ai-testcase-generator-container {
    width: 95%;
    height: 90vh;
  }
  
  .test-cases-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
  
  .test-cases-actions {
    width: 100%;
    justify-content: space-between;
  }
  
  .test-case-editor {
    width: 95%;
    height: 80vh;
  }
}

/* Test Plans & Suites View Styles */
.view-toggle {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.view-toggle-btn {
  padding: 8px 16px;
  border: 1px solid #dee2e6;
  background-color: var(--bg-tertiary, #f8f9fa);
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  color: #495057;
  cursor: pointer;
  transition: all 0.2s ease;
}

.view-toggle-btn:hover {
  background-color: var(--bg-tertiary, #e9ecef);
}

.view-toggle-btn.active {
  background-color: #0d6efd;
  border-color: #0d6efd;
  color: white;
}

.test-plans-view {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.test-strategy-toggle {
  display: flex;
  gap: 10px;
  margin-bottom: 16px;
}

.strategy-toggle-btn {
  padding: 6px 12px;
  border: 1px solid #dee2e6;
  background-color: var(--bg-tertiary, #f8f9fa);
  border-radius: 4px;
  font-size: 14px;
  color: #495057;
  cursor: pointer;
  transition: all 0.2s ease;
}

.strategy-toggle-btn:hover {
  background-color: var(--bg-tertiary, #e9ecef);
}

.strategy-toggle-btn.active {
  background-color: var(--bg-tertiary, #e9ecef);
  font-weight: 600;
  color: #212529;
  border-color: #adb5bd;
}

.test-plan-card {
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 20px;
  background-color: var(--surface, #fff);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.test-plan-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
}

.test-plan-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #212529;
}

.test-plan-meta {
  display: flex;
  gap: 12px;
}

.test-plan-scenarios {
  display: inline-block;
  padding: 4px 8px;
  background-color: var(--bg-tertiary, #e9ecef);
  border-radius: 4px;
  font-size: 12px;
  color: #495057;
}

.automation-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  background-color: #e2e8f0;
  color: #4a5568;
}

.automation-badge.small {
  font-size: 11px;
  padding: 2px 6px;
}

.test-plan-description {
  margin-bottom: 16px;
  color: #6c757d;
  font-size: 14px;
}

.test-strategy-section {
  margin-bottom: 20px;
  padding: 16px;
  background-color: var(--bg-tertiary, #f8f9fa);
  border-radius: 8px;
}

.test-strategy-section h4 {
  margin: 0 0 12px 0;
  font-size: 16px;
  font-weight: 600;
  color: #212529;
}

.test-strategy-section h5 {
  margin: 16px 0 8px 0;
  font-size: 14px;
  font-weight: 600;
  color: #495057;
}

.strategy-overview {
  margin-bottom: 12px;
  color: #495057;
  font-size: 14px;
}

.strategy-recommendations {
  margin: 0 0 16px 0;
  padding-left: 20px;
}

.strategy-recommendations li {
  margin-bottom: 6px;
  color: #495057;
  font-size: 14px;
}

.suggested-frameworks {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
}

.framework-badge {
  display: inline-block;
  padding: 4px 8px;
  background-color: var(--bg-tertiary, #e9ecef);
  border-radius: 4px;
  font-size: 12px;
  color: #495057;
}

.strategy-effort {
  font-weight: 600;
  color: #495057;
  font-size: 14px;
}

.test-suites-section {
  margin-top: 20px;
}

.test-suites-section h4 {
  margin: 0 0 16px 0;
  font-size: 16px;
  font-weight: 600;
  color: #212529;
}

.test-suites-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 16px;
}

.test-suite-card {
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 16px;
  background-color: var(--surface, #fff);
  transition: all 0.2s ease;
}

.test-suite-card.clickable {
  cursor: pointer;
  position: relative;
}

.test-suite-card.clickable:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-color: #0d6efd;
  transform: translateY(-2px);
}

.test-suite-card:hover {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}

.test-suite-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.test-suite-header h5 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #212529;
}

.suite-scenario-count {
  font-size: 12px;
  color: #6c757d;
}

.test-suite-description {
  margin-bottom: 12px;
  color: #6c757d;
  font-size: 14px;
}

.test-suite-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.view-link {
  color: #0d6efd;
  font-size: 12px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.test-suite-card:hover .view-link {
  text-decoration: underline;
}

/* Responsive styles for test plans view */
@media (max-width: 768px) {
  .test-suites-list {
    grid-template-columns: 1fr;
  }
  
  .test-plan-header {
    flex-direction: column;
    gap: 8px;
  }
  
  .test-plan-meta {
    flex-direction: column;
    gap: 8px;
  }
}

.test-case-card.editing-mode {
  border: 2px solid #007bff;
  background-color: var(--primary-subtle, #f8fbff);
  padding: 15px;
}


.edit-title-input,
.edit-description-textarea,
.edit-expected-result-textarea,
.edit-precondition-textarea,
.step-text-textarea,
.parameter-name-input,
.parameter-value-input,
.edit-source-input,
.edit-time-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  font-family: inherit;
  resize: none;
  min-height: auto;
  line-height: 1.4;
  overflow: visible;
  box-sizing: border-box;
}

 
.edit-description-textarea,
.edit-expected-result-textarea,
.edit-precondition-textarea,
.step-text-textarea {
  resize: vertical;
  width: 50rem;
  min-height: 60px;
  overflow: auto;
  height: auto;
}


.edit-title-input,
.edit-source-input,
.edit-time-input,
.parameter-name-input,
.parameter-value-input {
  width: 50rem;
  height: auto;
  min-height: 38px;
  resize: none;
  overflow: hidden;
}


.editable-meta {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  align-items: center;
}

.meta-field {
  display: flex;
  align-items: center;
  gap: 6px;
}

.meta-field label {
  font-size: 12px;
  font-weight: 600;
  color: #666;
  white-space: nowrap;
}

.edit-type-select,
.edit-priority-select,
.edit-risk-select,
.edit-impact-select,
.step-type-select {
  padding: 6px 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 12px;
  min-width: 100px;
  height: 32px;
}


.editable-preconditions .editable-precondition-item {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
  align-items: flex-start;
}

.edit-precondition-textarea {
  flex: 1 1;
  min-height: 60px;
}


.editable-steps .editable-step {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
  align-items: flex-start;
}

.step-text-textarea {
  flex: 1 1;
  width: 30rem;
  min-height: 60px;
}


.editable-parameterized-suggestions {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.editable-parameter-group {
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 12px;
  background: var(--bg-tertiary, #fafafa);
}

.parameter-header {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 8px;
}

.parameter-name-input {
  flex: 1 1;
  font-weight: 600;
}

.parameter-values-editable {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.parameter-value-item {
  display: flex;
  gap: 8px;
  align-items: center;
}

.parameter-value-input {
  flex: 1 1;
}


.remove-step-btn,
.remove-precondition-btn,
.remove-parameter-btn,
.remove-value-btn {
  background: #ff4757;
  color: white;
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.add-step-btn,
.add-precondition-btn,
.add-parameter-btn,
.add-value-btn {
  background: #007bff;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  margin-top: 8px;
}

.remove-step-btn:hover,
.remove-precondition-btn:hover,
.remove-parameter-btn:hover,
.remove-value-btn:hover {
  background: #ff3742;
}

.add-step-btn:hover,
.add-precondition-btn:hover,
.add-parameter-btn:hover,
.add-value-btn:hover {
  background: #0056b3;
}


.test-case-section {
  margin-bottom: 16px;
}

.test-case-section h4 {
  margin-bottom: 8px;
  color: var(--text-primary, #333);
  font-size: 14px;
  background: transparent;
  box-shadow: none;
  border: none;
  text-shadow: none;
}


.btn-spinner-small {
  width: 16px;
  height: 16px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}`, "",{"version":3,"sources":["webpack://./src/styles/ai-testcase-generator.css"],"names":[],"mappings":"AAAA,kCAAkC;;AAElC,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,6CAA6C;EAC7C,mCAAmC;AACrC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA,yBAAyB;AACzB;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA,wCAAwC;AACxC;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,qBAAqB;AACrB;EACE,sCAAsC;EACtC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,6CAA6C;EAC7C,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;EAC7C,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,6BAA6B;EAC7B,uEAAuE;EACvE,QAAQ;EACR,SAAS;EACT,aAAa;EACb,oBAAoB;EACpB,wBAAwB;EACxB,WAAW;EACX,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE;IACE,OAAO;EACT;AACF;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,0CAA0C;EAC1C,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;CAEC;EACC,gDAAgD;EAChD,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,qDAAqD;EACrD,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,yBAAyB;EACzB,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,6CAA6C;EAC7C,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,uBAAuB;EACvB,uCAAuC;AACzC;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,sCAAsC;EACtC,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA,8EAA8E;AAC9E;;;EAGE,8FAA8F;EAC9F,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa,EAAE,iBAAiB;EAChC,UAAU;EACV,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;;;EAGE,kBAAkB,EAAE,2CAA2C;EAC/D,UAAU;EACV,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,qCAAqC;AACvC;AACA;EACE,qCAAqC;EACrC,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB,EAAE,iCAAiC;EACnD,qBAAqB;EACrB,iBAAiB;EACjB,oDAAoD;EACpD,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iCAAiC;EACjC,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,6CAA6C;EAC7C,8CAA8C;EAC9C,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,6CAA6C;EAC7C,kBAAkB;EAClB,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,0CAA0C;EAC1C,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,iCAAiC;EACjC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,mCAAmC;AACrC;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,6CAA6C;EAC7C,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,eAAe;AACf;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,UAAU;IACV,YAAY;EACd;AACF;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,6CAA6C;EAC7C,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,6CAA6C;EAC7C,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;EAC7C,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sCAAsC;EACtC,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,6CAA6C;EAC7C,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,6CAA6C;EAC7C,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,6CAA6C;EAC7C,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,0CAA0C;AAC1C;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;AACF;;AAEA;EACE,yBAAyB;EACzB,gDAAgD;EAChD,aAAa;AACf;;;AAGA;;;;;;;;;EASE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;;AAGA;;;;EAIE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;;;AAGA;;;;;EAKE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;;AAGA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;;;;;EAKE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;;AAGA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;;AAGA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;;AAGA;;;;EAIE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;;;;EAIE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,eAAe;AACjB;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;;;;EAIE,mBAAmB;AACrB;;;AAGA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC","sourcesContent":["/* AI Test Case Generator Styles */\n\n/* BDD Scenario Styles */\n.bdd-steps {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin-top: 0.5rem;\n}\n\n.bdd-step {\n  display: flex;\n  padding: 0.5rem;\n  border-radius: 4px;\n  background-color: var(--bg-tertiary, #f8f9fa);\n  color: var(--text-primary, #212529);\n}\n\n.bdd-step.given {\n  border-left: 3px solid #4a6cf7;\n}\n\n.bdd-step.when {\n  border-left: 3px solid #fd7e14;\n}\n\n.bdd-step.then {\n  border-left: 3px solid #28a745;\n}\n\n.step-keyword {\n  font-weight: 600;\n  margin-right: 0.5rem;\n  min-width: 50px;\n}\n\n.step-text {\n  flex: 1;\n}\n\n/* Scenario Type Badges */\n.scenario-type-badge {\n  display: inline-block;\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  margin-right: 0.5rem;\n}\n\n.scenario-type-badge.bdd {\n  background-color: rgba(74, 108, 247, 0.1);\n  color: #4a6cf7;\n}\n\n.scenario-type-badge.happy_path {\n  background-color: rgba(40, 167, 69, 0.1);\n  color: #28a745;\n}\n\n.scenario-type-badge.edge_case {\n  background-color: rgba(253, 126, 20, 0.1);\n  color: #fd7e14;\n}\n\n/* Card styling based on scenario type */\n.test-case-card.bdd-card {\n  border-top: 3px solid #4a6cf7;\n}\n\n.test-case-card.happy_path-card {\n  border-top: 3px solid #28a745;\n}\n\n.test-case-card.edge_case-card {\n  border-top: 3px solid #fd7e14;\n}\n\n/* Analysis Results */\n.analysis-results {\n  background-color: var(--surface, #fff);\n  border-radius: 8px;\n  padding: 1rem;\n  margin-bottom: 1rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.analysis-results h3 {\n  font-size: 1rem;\n  font-weight: 600;\n  margin-top: 0;\n  margin-bottom: 0.75rem;\n  color: var(--text-dark, #2d3748);\n}\n\n.analysis-stats {\n  display: flex;\n  gap: 1.5rem;\n}\n\n.analysis-stat {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.stat-label {\n  font-size: 0.75rem;\n  color: var(--text-muted, #718096);\n}\n\n.stat-value {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--text-dark, #2d3748);\n}\n\n.back-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  background-color: var(--bg-tertiary, #f8f9fa);\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  color: #495057;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.2s ease;\n}\n\n.back-btn:hover {\n  background-color: var(--bg-tertiary, #e9ecef);\n  border-color: #adb5bd;\n  color: #212529;\n}\n\n.back-btn:active {\n  background-color: #dee2e6;\n  transform: translateY(1px);\n}\n.ai-testcase-generator-overlay {\n  position: fixed;\n  top: var(--rt-topbar-h, 56px);\n  left: var(--rt-shell-sidebar-offset, var(--rt-sidebar-collapsed, 68px));\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: stretch;\n  justify-content: stretch;\n  z-index: 25;\n  animation: fadeIn 0.2s ease;\n  transition: left 180ms ease;\n}\n\n@media (max-width: 1024px) {\n  .ai-testcase-generator-overlay {\n    left: 0;\n  }\n}\n\n.ai-testcase-generator-container {\n  background-color: var(--surface, #fff);\n  margin-top:8rem;\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  width: 100vw;\n  /* max-width: 1200px; */\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  animation: slideUp 0.3s ease;\n  color: var(--text-primary, #212529);\n}\n\n.generator-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 24px;\n  border-bottom: 1px solid var(--border-color, #e9ecef);\n}\n\n.generator-header h2 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: var(--text-primary, #212529);\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.ai-badge {\n  background: linear-gradient(135deg, #6366f1, #8b5cf6);\n  color: white;\n  font-size: 12px;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-weight: 500;\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: var(--text-muted, #6c757d);\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n}\n\n .close-btn:hover {\n  /* background-color: var(--bg-light, #f8f9fa); */\n  color: var(--text-primary, #212529);\n} \n\n.item-details {\n  padding: 16px 24px;\n  border-bottom: 1px solid var(--border-color, #e9ecef);\n  background-color: var(--bg-light, #f8f9fa);\n}\n\n.item-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 8px;\n}\n\n.item-type-badge {\n  background-color: #e3f2fd;\n  color: #0d6efd;\n  font-size: 12px;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-weight: 600;\n}\n\n.item-title h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--text-primary, #212529);\n}\n\n.item-description {\n  margin: 0;\n  color: var(--text-secondary, #6c757d);\n  font-size: 14px;\n}\n\n.generator-content {\n  flex: 1;\n  padding: 24px;\n  overflow-y: auto;\n}\n\n/* Loading Spinner */\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  padding: 40px;\n}\n\n.spinner {\n  width: 50px;\n  height: 50px;\n  border: 4px solid rgba(0, 0, 0, 0.1);\n  border-radius: 50%;\n  border-top-color: #0d6efd;\n  animation: spin 1s ease-in-out infinite;\n  margin-bottom: 20px;\n}\n\n.loading-subtext {\n  color: var(--text-muted, #6c757d);\n  font-size: 14px;\n  margin-top: 8px;\n  text-align: center;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Test Cases Header */\n.test-cases-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.test-cases-title {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.test-cases-title h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--text-primary, #212529);\n}\n\n.regenerate-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background-color: var(--bg-tertiary, #f8f9fa);\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  padding: 6px 12px;\n  font-size: 14px;\n  color: #495057;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.regenerate-btn:hover {\n  background-color: var(--bg-tertiary, #e9ecef);\n}\n\n.regenerate-btn svg {\n  color: #0d6efd;\n}\n.generate-test-case-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background-color: blue;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  padding: 6px 12px;\n  font-size: 14px;\n  color: white;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n.test-cases-actions {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.select-all-container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.select-all-container input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n}\n\n.select-all-container label {\n  font-size: 14px;\n  color: var(--text-primary, #212529);\n}\n\n.save-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background-color: #0d6efd;\n  border: none;\n  border-radius: 4px;\n  padding: 8px 16px;\n  font-size: 14px;\n  font-weight: 500;\n  color: white;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.save-btn:hover {\n  background-color: #0b5ed7;\n}\n\n.save-btn:disabled {\n  background-color: #b6d4fe;\n  cursor: not-allowed;\n}\n\n.save-btn.saving {\n  background-color: #6c757d;\n}\n\n.save-btn.saved {\n  background-color: #28a745;\n}\n\n.btn-spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-radius: 50%;\n  border-top-color: white;\n  animation: spin 1s ease-in-out infinite;\n}\n\n/* Test Cases List */\n.test-cases-list {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.test-case-card {\n  border: 1px solid var(--border, #dee2e6);\n  border-radius: 8px;\n  padding: 16px;\n  background-color: var(--surface, #fff);\n  color: var(--text-primary, #212529);\n  transition: all 0.2s ease;\n}\n\n/* Collapsible behavior: animate height and opacity of content when toggling */\n.test-case-card .test-case-meta,\n.test-case-card .test-case-description,\n.test-case-card .test-case-content {\n  transition: max-height 0.32s cubic-bezier(.2,.8,.2,1), opacity 0.2s ease, transform 0.28s ease;\n  overflow: hidden;\n}\n\n.test-case-card.collapsed .test-case-meta,\n.test-case-card.collapsed .test-case-description,\n.test-case-card.collapsed .test-case-content {\n  max-height: 0; /* hide content */\n  opacity: 0;\n  transform: translateY(-6px);\n  pointer-events: none;\n}\n\n.test-case-card.open .test-case-meta,\n.test-case-card.open .test-case-description,\n.test-case-card.open .test-case-content {\n  max-height: 2000px; /* large value to allow content to expand */\n  opacity: 1;\n  transform: translateY(0);\n  pointer-events: auto;\n}\n\n/* Collapsed summary styling */\n.collapsed-summary {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  color: var(--text-secondary, #6c757d);\n}\n.collapsed-summary .short-description {\n  color: var(--text-secondary, #6c757d);\n  font-size: 13px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 60%;\n}\n\n/* Header caret indicator */\n.test-case-header::after {\n  content: '\\25BE'; /* small down-pointing triangle */\n  display: inline-block;\n  margin-left: 12px;\n  transition: transform 0.28s ease, opacity 0.18s ease;\n  opacity: 0.7;\n}\n.test-case-card.open .test-case-header::after {\n  transform: rotate(180deg);\n}\n.test-case-card.collapsed .test-case-header::after {\n  transform: rotate(0deg);\n}\n\n.test-case-card.selected {\n  border-color: #0d6efd;\n  box-shadow: 0 0 0 1px #0d6efd;\n}\n\n.test-case-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 12px;\n}\n\n.test-case-selection {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n}\n\n.test-case-selection input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  margin-top: 2px;\n}\n\n.test-case-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--text-primary, #212529);\n  cursor: pointer;\n}\n\n.test-case-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.edit-test-case-btn {\n  background: none;\n  border: none;\n  color: var(--text-muted, #6c757d);\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.edit-test-case-btn:hover {\n  background-color: var(--bg-tertiary, #f8f9fa);\n  color: #0d6efd;\n}\n\n.test-case-meta {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.priority-badge {\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.priority-high {\n  background-color: #f8d7da;\n  color: #dc3545;\n}\n\n.priority-medium {\n  background-color: #fff3cd;\n  color: #fd7e14;\n}\n\n.priority-low {\n  background-color: #d1e7dd;\n  color: #20c997;\n}\n\n.priority-critical {\n  background-color: #dc3545;\n  color: white;\n}\n\n.risk-impact-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n  background-color: #e2e8f0;\n  color: #4a5568;\n}\n\n.time-estimate {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  color: var(--text-muted, #6c757d);\n  font-size: 12px;\n}\n\n.test-case-description {\n  margin-bottom: 16px;\n  color: var(--text-secondary, #6c757d);\n  font-size: 14px;\n}\n\n.test-case-content {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.test-case-section {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.test-case-section h4 {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary, #212529);\n  background: transparent;\n  box-shadow: none;\n  border: none;\n  padding: 0;\n  text-shadow: none;\n}\n\n/* Preconditions List */\n.preconditions-list {\n  margin: 0;\n  padding-left: 20px;\n}\n\n.preconditions-list li {\n  margin-bottom: 4px;\n  color: var(--text-secondary, #495057);\n  font-size: 14px;\n}\n\n/* Expected Result */\n.expected-result {\n  padding: 8px 12px;\n  background-color: var(--bg-tertiary, #f8f9fa);\n  border-left: 3px solid var(--success, #28a745);\n  border-radius: 4px;\n  color: var(--text-secondary, #495057);\n  font-size: 14px;\n}\n\n/* Parameterized Test Suggestions */\n.parameterized-suggestions {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.parameter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.parameter-name {\n  font-weight: 600;\n  font-size: 14px;\n  color: var(--text-primary, #212529);\n}\n\n.parameter-values {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.parameter-value {\n  display: inline-block;\n  padding: 4px 8px;\n  background-color: var(--bg-tertiary, #e9ecef);\n  border-radius: 4px;\n  font-size: 12px;\n  color: var(--text-secondary, #495057);\n}\n\n.test-case-section ol, .test-case-section ul {\n  margin: 0;\n  padding-left: 20px;\n}\n\n.test-case-section li {\n  margin-bottom: 4px;\n  color: var(--text-secondary, #495057);\n  font-size: 14px;\n}\n\n.test-case-section p {\n  margin: 0;\n  color: var(--text-secondary, #495057);\n  font-size: 14px;\n}\n\n.no-test-cases {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n  text-align: center;\n  color: var(--text-muted, #6c757d);\n}\n\n/* Test Case Editor */\n.test-case-editor-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 3000;\n  animation: fadeIn 0.2s ease;\n}\n\n.test-case-editor {\n  background-color: var(--surface, #fff);\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  width: 80%;\n  max-width: 800px;\n  height: 70vh;\n  display: flex;\n  flex-direction: column;\n  animation: slideUp 0.3s ease;\n}\n\n.editor-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 24px;\n  border-bottom: 1px solid var(--border-color, #e9ecef);\n}\n\n.editor-header h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--text-primary, #212529);\n}\n\n.close-editor-btn {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: var(--text-muted, #6c757d);\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n}\n\n.close-editor-btn:hover {\n  background-color: var(--bg-light, #f8f9fa);\n  color: var(--text-primary, #212529);\n}\n\n.editor-content {\n  flex: 1;\n  padding: 16px 24px;\n  overflow-y: auto;\n}\n\n.editor-textarea {\n  width: 100%;\n  height: 100%;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  padding: 12px;\n  font-family: monospace;\n  font-size: 14px;\n  resize: none;\n}\n\n.editor-footer {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 24px;\n  border-top: 1px solid var(--border-color, #e9ecef);\n}\n\n.cancel-btn {\n  background-color: var(--bg-tertiary, #f8f9fa);\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  padding: 8px 16px;\n  font-size: 14px;\n  color: #495057;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.cancel-btn:hover {\n  background-color: var(--bg-tertiary, #e9ecef);\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes slideUp {\n  from {\n    transform: translateY(20px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n/* Responsive Styles */\n@media (max-width: 768px) {\n  .ai-testcase-generator-container {\n    width: 95%;\n    height: 90vh;\n  }\n  \n  .test-cases-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n  }\n  \n  .test-cases-actions {\n    width: 100%;\n    justify-content: space-between;\n  }\n  \n  .test-case-editor {\n    width: 95%;\n    height: 80vh;\n  }\n}\n\n/* Test Plans & Suites View Styles */\n.view-toggle {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.view-toggle-btn {\n  padding: 8px 16px;\n  border: 1px solid #dee2e6;\n  background-color: var(--bg-tertiary, #f8f9fa);\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #495057;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.view-toggle-btn:hover {\n  background-color: var(--bg-tertiary, #e9ecef);\n}\n\n.view-toggle-btn.active {\n  background-color: #0d6efd;\n  border-color: #0d6efd;\n  color: white;\n}\n\n.test-plans-view {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.test-strategy-toggle {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 16px;\n}\n\n.strategy-toggle-btn {\n  padding: 6px 12px;\n  border: 1px solid #dee2e6;\n  background-color: var(--bg-tertiary, #f8f9fa);\n  border-radius: 4px;\n  font-size: 14px;\n  color: #495057;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.strategy-toggle-btn:hover {\n  background-color: var(--bg-tertiary, #e9ecef);\n}\n\n.strategy-toggle-btn.active {\n  background-color: var(--bg-tertiary, #e9ecef);\n  font-weight: 600;\n  color: #212529;\n  border-color: #adb5bd;\n}\n\n.test-plan-card {\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n  padding: 20px;\n  background-color: var(--surface, #fff);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.test-plan-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 12px;\n}\n\n.test-plan-header h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #212529;\n}\n\n.test-plan-meta {\n  display: flex;\n  gap: 12px;\n}\n\n.test-plan-scenarios {\n  display: inline-block;\n  padding: 4px 8px;\n  background-color: var(--bg-tertiary, #e9ecef);\n  border-radius: 4px;\n  font-size: 12px;\n  color: #495057;\n}\n\n.automation-badge {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  background-color: #e2e8f0;\n  color: #4a5568;\n}\n\n.automation-badge.small {\n  font-size: 11px;\n  padding: 2px 6px;\n}\n\n.test-plan-description {\n  margin-bottom: 16px;\n  color: #6c757d;\n  font-size: 14px;\n}\n\n.test-strategy-section {\n  margin-bottom: 20px;\n  padding: 16px;\n  background-color: var(--bg-tertiary, #f8f9fa);\n  border-radius: 8px;\n}\n\n.test-strategy-section h4 {\n  margin: 0 0 12px 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #212529;\n}\n\n.test-strategy-section h5 {\n  margin: 16px 0 8px 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #495057;\n}\n\n.strategy-overview {\n  margin-bottom: 12px;\n  color: #495057;\n  font-size: 14px;\n}\n\n.strategy-recommendations {\n  margin: 0 0 16px 0;\n  padding-left: 20px;\n}\n\n.strategy-recommendations li {\n  margin-bottom: 6px;\n  color: #495057;\n  font-size: 14px;\n}\n\n.suggested-frameworks {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n\n.framework-badge {\n  display: inline-block;\n  padding: 4px 8px;\n  background-color: var(--bg-tertiary, #e9ecef);\n  border-radius: 4px;\n  font-size: 12px;\n  color: #495057;\n}\n\n.strategy-effort {\n  font-weight: 600;\n  color: #495057;\n  font-size: 14px;\n}\n\n.test-suites-section {\n  margin-top: 20px;\n}\n\n.test-suites-section h4 {\n  margin: 0 0 16px 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #212529;\n}\n\n.test-suites-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 16px;\n}\n\n.test-suite-card {\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n  padding: 16px;\n  background-color: var(--surface, #fff);\n  transition: all 0.2s ease;\n}\n\n.test-suite-card.clickable {\n  cursor: pointer;\n  position: relative;\n}\n\n.test-suite-card.clickable:hover {\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  border-color: #0d6efd;\n  transform: translateY(-2px);\n}\n\n.test-suite-card:hover {\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n}\n\n.test-suite-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.test-suite-header h5 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #212529;\n}\n\n.suite-scenario-count {\n  font-size: 12px;\n  color: #6c757d;\n}\n\n.test-suite-description {\n  margin-bottom: 12px;\n  color: #6c757d;\n  font-size: 14px;\n}\n\n.test-suite-meta {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.view-link {\n  color: #0d6efd;\n  font-size: 12px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.test-suite-card:hover .view-link {\n  text-decoration: underline;\n}\n\n/* Responsive styles for test plans view */\n@media (max-width: 768px) {\n  .test-suites-list {\n    grid-template-columns: 1fr;\n  }\n  \n  .test-plan-header {\n    flex-direction: column;\n    gap: 8px;\n  }\n  \n  .test-plan-meta {\n    flex-direction: column;\n    gap: 8px;\n  }\n}\n\n.test-case-card.editing-mode {\n  border: 2px solid #007bff;\n  background-color: var(--primary-subtle, #f8fbff);\n  padding: 15px;\n}\n\n\n.edit-title-input,\n.edit-description-textarea,\n.edit-expected-result-textarea,\n.edit-precondition-textarea,\n.step-text-textarea,\n.parameter-name-input,\n.parameter-value-input,\n.edit-source-input,\n.edit-time-input {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n  font-family: inherit;\n  resize: none;\n  min-height: auto;\n  line-height: 1.4;\n  overflow: visible;\n  box-sizing: border-box;\n}\n\n \n.edit-description-textarea,\n.edit-expected-result-textarea,\n.edit-precondition-textarea,\n.step-text-textarea {\n  resize: vertical;\n  width: 50rem;\n  min-height: 60px;\n  overflow: auto;\n  height: auto;\n}\n\n\n.edit-title-input,\n.edit-source-input,\n.edit-time-input,\n.parameter-name-input,\n.parameter-value-input {\n  width: 50rem;\n  height: auto;\n  min-height: 38px;\n  resize: none;\n  overflow: hidden;\n}\n\n\n.editable-meta {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.meta-field {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.meta-field label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #666;\n  white-space: nowrap;\n}\n\n.edit-type-select,\n.edit-priority-select,\n.edit-risk-select,\n.edit-impact-select,\n.step-type-select {\n  padding: 6px 8px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 12px;\n  min-width: 100px;\n  height: 32px;\n}\n\n\n.editable-preconditions .editable-precondition-item {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 8px;\n  align-items: flex-start;\n}\n\n.edit-precondition-textarea {\n  flex: 1;\n  min-height: 60px;\n}\n\n\n.editable-steps .editable-step {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 8px;\n  align-items: flex-start;\n}\n\n.step-text-textarea {\n  flex: 1;\n  width: 30rem;\n  min-height: 60px;\n}\n\n\n.editable-parameterized-suggestions {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.editable-parameter-group {\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  padding: 12px;\n  margin-bottom: 12px;\n  background: var(--bg-tertiary, #fafafa);\n}\n\n.parameter-header {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.parameter-name-input {\n  flex: 1;\n  font-weight: 600;\n}\n\n.parameter-values-editable {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.parameter-value-item {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.parameter-value-input {\n  flex: 1;\n}\n\n\n.remove-step-btn,\n.remove-precondition-btn,\n.remove-parameter-btn,\n.remove-value-btn {\n  background: #ff4757;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  cursor: pointer;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.add-step-btn,\n.add-precondition-btn,\n.add-parameter-btn,\n.add-value-btn {\n  background: #007bff;\n  color: white;\n  border: none;\n  padding: 6px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n  margin-top: 8px;\n}\n\n.remove-step-btn:hover,\n.remove-precondition-btn:hover,\n.remove-parameter-btn:hover,\n.remove-value-btn:hover {\n  background: #ff3742;\n}\n\n.add-step-btn:hover,\n.add-precondition-btn:hover,\n.add-parameter-btn:hover,\n.add-value-btn:hover {\n  background: #0056b3;\n}\n\n\n.test-case-section {\n  margin-bottom: 16px;\n}\n\n.test-case-section h4 {\n  margin-bottom: 8px;\n  color: var(--text-primary, #333);\n  font-size: 14px;\n  background: transparent;\n  box-shadow: none;\n  border: none;\n  text-shadow: none;\n}\n\n\n.btn-spinner-small {\n  width: 16px;\n  height: 16px;\n  border: 2px solid #f3f3f3;\n  border-top: 2px solid #007bff;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
